import Http from "../engine/Http";
import useAuthenticationHeader from "./AuthenticationHeader.hook";

const useHttp = () => {
  const authenticationHeader = useAuthenticationHeader();

  const get = (url: string) => Http.get(url, [ authenticationHeader ]);
  
  const post = (url: string, data: any) => Http.post(url, data, [ authenticationHeader]);

  const put = (url: string, data: any) => Http.put(url, data, [ authenticationHeader ]);

  const sendDelete = (url: string) => Http.delete(url, [ authenticationHeader ]);

  const patch = (url: string, data: any) => Http.patch(url, data, [ authenticationHeader ]);

  return {
    get,
    post,
    put,
    patch,
    delete: sendDelete
  }
};

export default useHttp;